<template>
  <el-dialog
    id="publishModal"
    :title="$t('leader.coworker.publishList')"
    :visible.sync="showLocal"
    :width="dialogWidth"
    center
  >
    <div
      v-if="role_type === 'leader'"
      class="content"
    >
      <div>
        {{ $t('leader.coworker.askPublishConfirm') }}:
      </div>

      <div>
        {{ $t('leader.coworker.emailHeader') }}
      </div>

      <div>
        <i18n path="leader.coworker.emailBody">
          <template #leader>
            {{ leaderFirstName }}
          </template>
        </i18n>
      </div>

      <div>
        {{ $t('leader.coworker.emailFooter') }}
      </div>

      <div>
        {{ $t('leader.coworker.kindRegards') }}
      </div>

      <div>
        Global Coach Group
      </div>
    </div>

    <div
      v-else
      class="content"
    >
      {{ $t('leader.coworker.askPublishConfirmCoach') }}
    </div>

    <div class="buttonWrap">
      <el-button
        type="primary"
        round
        @click="publish"
      >
        <span v-if="role_type === 'coach'">
          {{ $t('common.confirm') }}
        </span>
        <span v-else>
          {{ $t('common.yes') }}
        </span>
      </el-button>
      <!--<el-button
        type="default"
        round
        @click="showLocal = false"
      >
        {{ $t('common.no') }}
      </el-button>-->
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import api from '@/api';
import dialog from '@/mixins/dialog';

export default {
  mixins: [dialog],

  props: {
    type: {
      type: String,
      default: '',
    },

    published: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      role_type: (state) => state.user.user.role_type,
      coach: (state) => state.myCoach.coach,
    }),

    leaderFirstName() {
      let name = `[${this.$t('leader.coworker.leaderName')}]`;
      if (this.user && this.user.user && this.user.user.first_name) {
        name = this.user.user.first_name;
      }
      return name;
    },

    coachFirstName() {
      let name = `[${this.$t('leader.coworker.coachName')}]`;
      if (this.coach && this.coach.first_name) {
        name = this.coach.first_name;
      }
      return name;
    },
  },

  methods: {
    ...mapActions('processStatus', [
      'fetchProcess',
    ]),

    async publish() {
      try {
        if (this.role_type === 'coach') {
          await api.publishLeaderCoworker(this.$route.params.id);
        } else {
          await api.publishStakeholders();
        }
        const publishMsg = this.role_type === 'coach'
          ? this.$t('leader.coworker.publishResultCoach') : this.$t('leader.coworker.publishResult');
        this.$alert(publishMsg, '', {
          confirmButtonText: this.$t('common.close'),
          callback: () => {
            if (this.role_type === 'leader') {
              this.fetchProcess();
            }
            this.$message.success(this.$t('leader.coworker.published'));
            this.$emit('update:published', true);
            this.showLocal = false;
          },
        });
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #publishModal {
    .content {
      div {
        word-break: break-word;
        white-space: normal;
        padding: 10px 0;
        font-size: 1rem;
      }
    }

    .buttonWrap {
      text-align: center;
      padding: 20px 0 0;

      .el-button {
        width: 20%;
        max-width: 130px;
        min-width: 60px;
        padding: 13px 0;
      }
    }
  }
</style>

<style lang="scss">
  #publishModal {
    .el-dialog__body {
      padding: 0 25px 25px;
    }
  }
</style>
